<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary"
             link to="/marketplace/cadastro-oferta"
             depressed
             class="normal-btn-text rounded-tag-small">
        <v-icon left>mdi-plus</v-icon>
        Nova oferta
      </v-btn>
      <v-btn depressed
             class="ml-3 normal-btn-text rounded-tag-small"
             color="primary" link to="/marketplace/ofertas/edicao-rapida">
        Edição rápida
      </v-btn>
      <v-spacer/>

      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma oferta ou código"
                      class="rounded-card"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('listagemMarketplaceOfertas', ['stringFilter']),
    searchText: {
      get() {
        return this.$store.getters['listagemMarketplaceOfertas/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemMarketplaceOfertas/searchText', searchText);
      },
    },
  },
  methods: {
    onClickRefresh() {
      this.$emit('refresh');
    },
    onChangeSearchText() {
      this.$emit('change');
    },
  },
};
</script>
